import React from "react";
import { Globe2, GraduationCap } from "lucide-react";
import logo from "../img/logooducal.png";
import img from "../img/oducalbg.png";
const Hero = () => {
  return (
    <header className="hero-container">
      <div className="hero-background"   style={{
        backgroundImage: `url(${img})`,
        
      }}></div>
      <div className="hero-content-wrapper fade-in">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            marginBottom: "40px",
          }}
        >
          <div className="icon200 "> 
            <br></br>  <br></br>
      <img src={logo}></img></div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            marginBottom: "20px",
          }}
        >
          <span
            className="font-serif"
            style={{ fontSize: "3rem", color: "#c4923e" }}
          >
            VIII
          </span>
          <div
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              color: "#1a2b56",
              letterSpacing: "2px",
            }}
          >
            ENCUENTRO RED DE
            <br />
            COMUNICACIÓN DE ODUCAL
          </div>
        </div>

        <h1 className="hero-title font-serif">
          Narrar el
          <br />
          bien común
        </h1>

        <p
          style={{ color: "#6b7280", maxWidth: "400px", marginBottom: "30px" }}
        >
          El desafío comunicacional de las universidades católicas.
        </p>

        <div style={{ marginBottom: "40px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="hero-tag">16 al 18 NOVIEMBRE</div>
            <div className="hero-tag-gold">Loja, Ecuador</div>
          </div>
        </div>

        <div
          style={{
            borderTop: "1px solid #eee",
            paddingTop: "30px",
            display: "flex",
            gap: "30px",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <GraduationCap size={24} color="#1a2b56" />
            <span style={{ fontWeight: "bold", fontSize: "12px" }}>UTPL</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
